export const HIDE_ALL_DIALOGS = 'HIDE_ALL_DIALOGS'
export const SHOW_DELETE_DIALOG = 'SHOW_DELETE_DIALOG'
export const SHOW_EDIT_DIALOG = 'SHOW_EDIT_DIALOG'
export const SHOW_LEAVE_DIALOG = 'SHOW_LEAVE_DIALOG'
export const SHOW_COPY_DIALOG = 'SHOW_COPY_DIALOG'
